export const AGGREGATED_FIELD_STATE = {
  COMMON: 'common',
  MULTIPLE: 'multiple',
  EMPTY: 'empty',
  NOT_APPLICABLE: 'notApplicable',
};

export const createAggregatedFieldStats = ({
  applicableCount = 0,
  withValueCount = 0,
  emptyCount = 0,
} = {}) => ({
  applicableCount,
  withValueCount,
  emptyCount,
});
